const mangoPulpData = {
  hero_section: {
    title: "Premium Mango Pulp Collection",
    description: "100% Natural • No Preservatives • Rich in Flavor",
    src: "videos/mango-processing.webm",
  },
  description: {
    title: "Zenvia Mango Pulp Collection",
    main_description:
      "Discover our range of 100% natural mango pulp (Totapuri, Alphonso, Kesar) crafted from the finest varieties sourced directly from farmers to preserve authentic tropical flavors and nutritional benefits.",
    segment_description:
      "Available in bulk aseptic packs, drums, and consumer-ready packs for B2B buyers and retail brands.",
    variety_description:
      "Trusted by institutional kitchens, restaurants, and global retail chains worldwide.",
  },
  main_product: {
    title: "Premium Mango Pulp",
    description: "Our premium mango pulp collection features the finest Indian mango varieties, each with distinct characteristics perfect for different applications. From the rich Alphonso to the tangy Totapuri, we offer authentic flavors that meet international quality standards.",
    image: "New-Images/Mango.png",
    mainFeatures: [
      "100% Natural with no preservatives",
      "Direct sourcing from premium farms",
      "HACCP & FSSAI certified processing",
      "Available in bulk and retail packs",
      "Export quality standards",
      "Cold chain maintained freshness"
    ],
    nutrition: {
      servingSize: "100g",
      calories: "162",
      fat: "0g",
      carbs: "39g (Sugar: 30g, Added: 15g)",
      fiber: "2g",
      protein: "1g",
      sodium: "2mg",
      potassium: "198mg"
    }
  },
  products: [
    {
      id: "1",
      name: "Alphonso Mango Pulp",
      image: "New-Images/Mango.png",
      features: [
        "Rich golden color",
        "Intense mango flavor",
        "Perfect for premium products"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    },
    {
      id: "2",
      name: "Totapuri Mango Pulp",
      image: "New-Images/Mango.png",
      features: [
        "High acidity content",
        "Perfect for beverages",
        "Consistent quality",
        "Long shelf life"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    },
    {
      id: "3",
      name: "Kesar Mango Pulp",
      image: "New-Images/Mango.png",
      features: [
        "Aromatic saffron notes",
        "Premium quality",
        "Rich texture",
        "Ideal for desserts"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    },
    {
      id: "4",
      name: "Mixed Mango Pulp",
      image: "New-Images/Mango.png",
      features: [
        "Blend of varieties",
        "Balanced flavor",
        "Cost-effective",
        "Versatile applications"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    }
  ],

  text_section: {
    title: "Zenvia Mango Pulp Excellence",
    description: "Our mango pulp is processed at our state-of-the-art facility from the finest handpicked mangoes sourced directly from farmers. With advanced processing techniques and cold chain excellence, we ensure consistent taste, texture, and nutritional value in every batch.",
  },
  
  feature_text_section: {
    title: "Perfect for Food Industry",
    subline: "From beverages to desserts – authentic mango flavor in every application!",
    description:
      "Ideal for juice manufacturers, ice cream producers, confectionery makers, and food service providers who demand consistent quality and authentic taste.",
  },
  
  feature_cards_info_card: [
    {
      id: 1,
      image: "beverage-applications.webp",
      title: "Beverage Applications",
      description:
        "Perfect for mango juices, smoothies, and tropical drink mixes with consistent flavor and color.",
    },
    {
      id: 2,
      image: "dessert-applications.webp",
      title: "Dessert Applications",
      description:
        "Ideal for ice creams, yogurts, cakes, and confectionery products requiring authentic mango taste.",
    },
    {
      id: 3,
      image: "food-service-applications.webp",
      title: "Food Service",
      description:
        "Excellent for restaurants, cafes, and catering services looking for premium mango ingredients.",
    },
  ],
  
  overlay_card: [
    {
      id: 1,
      key: "Natural Processing",
      image: "natural-processing.webp",
      title: "Natural Processing",
      description:
        "No artificial preservatives, colors, or additives—just pure, natural mango goodness",
    },
    {
      id: 2,
      key: "Quality Assurance",
      image: "quality-assurance.webp",
      title: "Quality Assurance",
      description:
        "Rigorous testing and quality control at every stage ensures premium standards",
    },
    {
      id: 3,
      key: "Consistent Supply",
      image: "consistent-supply.webp",
      title: "Consistent Supply",
      description:
        "Reliable production capacity and supply chain for your business needs",
    },
    {
      id: 4,
      key: "Versatile Applications",
      image: "versatile-applications.webp",
      title: "Versatile Applications",
      description:
        "Suitable for beverages, desserts, confectionery, and food service applications",
    },
  ],
  
  why_choose_section: {
    title: "Why Choose Our Mango Pulp",
    description: "Discover the perfect blend of quality, consistency, and authentic flavors that make our mango pulp the preferred choice for food manufacturers worldwide.",
  },
};

export default mangoPulpData;
